import { CopyButton } from '@/components/CopyButton';
import { useTranslation } from '@/i18n';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import { Tooltip } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC } from 'react';
import { SingleRowProps } from '../../type';
import styles from '../styles.module.scss';

const cx = classnames.bind(styles);

export const SingleRowWithCopy: FC<SingleRowProps> = ({ label, value }) => {
  const { t } = useTranslation();
  const container = useGlobalContainerRef();

  return (
    <div className={cx('rowDetailContainer')}>
      <div className={cx('rowDetailLabel')}>{label}</div>
      <div
        className={cx(
          'rowDetailValueContainer',
          'rowDetailValueWithCopyContainer'
        )}
      >
        <div className={cx('rowDetailValue')}>{value}</div>
        <Tooltip
          title={t('ap_payee_detail_drawer_copy_tooltip')}
          overlayClassName={cx('rowDetailCopyTooltipContainer')}
          getPopupContainer={container}
          destroyTooltipOnHide
        >
          <CopyButton size='xs' show text={value ?? ''} />
        </Tooltip>
      </div>
    </div>
  );
};

SingleRowWithCopy.displayName = 'SingleRowWithCopy';
